// src/jira/view/types.ts
var JiraViewAriResourceOwner = "jira", JiraViewAriResourceType = "view";

export {
  JiraViewAriResourceOwner,
  JiraViewAriResourceType
};
